import React from 'react';
import cn from 'classnames';
import { FormattedMessage, FormattedHTMLMessage } from 'react-intl';
import { ButtonForm, Form, FormGroup, Button } from 'reactstrap';
import Card from '@components//Card/Card';
import Layout from '@components/Layout/Layout';
import CustomControl from '@components/CustomControl/CustomControl';
import TwoFactorActivateBlock from '@components/TwoFactorAuth/TwoFactorActivateBlock';

import { authList } from '@components/TwoFactorAuth/twoFactorAuthHelpers';
import ChangePasswordBlock from '../../../components/Password/ChangePasswordBlock';

const { SMS, GAUTH, TELEGRAM } = authList;

const View = ({
  isLoading,
  botsInfo,
  isActivating,
  enableTwoFactorAuth,
  disableTwoFactorAuth,
  activateTwoFactorAuth,
  isActivateButtonRendering,
  isAuthMethodEnabled,
  responseInfo,
  two_factor,
  profile,
  onSubmit,
  showBotInfo,
  setActivatingState,
}) => {
  const { sessionId, validTill, message, code } = responseInfo;
  return (
    <Layout formattedTitle="pages.profile.security" className="security-page">
      <Layout.Col className="mb-4" lg={{ size: 12 }}>
        <div className="security-page-body">
          <div className="security-page-wrapper">
            <p className="security-page-title">
              <FormattedMessage
                id="pages.profile.security.two-factor"
                defaultMessage="Two-factor authentication"
              />
            </p>
            <p className="security-page-text">
              <FormattedMessage
                id="pages.profile.security.description"
                defaultMessage="Two-factor authentication is an additional level of security for your account and financial transactions. Only you can access your account, even if someone else has learned your password."
              />
            </p>
            <Form>
              {/* <FormGroup>
                <CustomControl
                  id={`two_factor_sms`}
                  name="two_factor_sms"
                  type="radio"
                  className="custom-control-xs"
                  disabled={two_factor.type === 2 && two_factor.is_active}
                  value={1}
                  onChange={enableTwoFactorAuth.bind(null, SMS)}
                  checked={isAuthMethodEnabled(SMS)}
                >
                  <FormattedMessage
                    id="pages.profile.security.controls.sms"
                    defaultMessage="Via SMS"
                  />
                </CustomControl>
              </FormGroup> */}
              {/* <FormGroup>
                <CustomControl
                  id={`two_factor_gauth`}
                  name="two_factor_gauth"
                  type="radio"
                  className="custom-control-xs"
                  disabled={two_factor.type !== 2 && two_factor.is_active}
                  value={1}
                  onChange={enableTwoFactorAuth.bind(null, GAUTH)}
                  checked={isAuthMethodEnabled(GAUTH)}
                >
                  <FormattedMessage
                    id="pages.profile.security.controls.gauth"
                    defaultMessage="Via Google Auth"
                  />
                </CustomControl>
              </FormGroup> */}

              {/* <FormGroup>
                <CustomControl
                  id={`two_factor_telegram`}
                  name="two_factor_telegram"
                  type="radio"
                  className="custom-control-xs"
                  disabled
                  // disabled={two_factor.type !== 4 && two_factor.is_active}
                  value={1}
                  onChange={enableTwoFactorAuth.bind(null, TELEGRAM)}
                  checked={isAuthMethodEnabled(TELEGRAM)}
                >
                  <FormattedMessage
                    id="pages.profile.security.controls.telegram"
                    defaultMessage="Via Telegram"
                  />
                </CustomControl>
              </FormGroup> */}

              <FormGroup>
                <CustomControl
                  id={`two_factor_gauth`}
                  name="two_factor_gauth"
                  type="checkbox"
                  className={cn('custom-checkbox-switch', 'two-factor-input')}
                  disabled={two_factor.type !== 2 && two_factor.is_active}
                  value={1}
                  onChange={() => {
                    enableTwoFactorAuth.bind(null, GAUTH)?.();
                    if (two_factor.is_active === 1) {
                      disableTwoFactorAuth();
                    } else {
                      setActivatingState(true);
                    }
                  }}
                  checked={two_factor.is_active}
                >
                  <div>
                    <h6>
                      <FormattedMessage
                        id="pages.profile.security.controls.gauth"
                        defaultMessage="Via Google Auth"
                      />
                    </h6>
                    <p>
                      <FormattedMessage
                        id="pages.profile.security.controls.gauth-text"
                        defaultMessage="Authentication app (Google Authenticator / 1Password / FreeOTP)"
                      />
                    </p>
                  </div>
                </CustomControl>
              </FormGroup>

              {/* {isActivateButtonRendering() && (
                <FormGroup className="security-page-button">
                  <Button
                    color="primary"
                    type="button"
                    onClick={activateTwoFactorAuth}
                    size="md"
                    className="form-group-btn"
                  >
                    <FormattedMessage
                      id="pages.profile.security.button.enable"
                      defaultMessage="Enable"
                    />
                  </Button>
                </FormGroup>
              )} */}

              {/* {two_factor.is_active === 1 && !isActivating && (
                <FormGroup className="security-page-button">
                  <Button
                    color="primary"
                    type="button"
                    onClick={() => disableTwoFactorAuth()}
                    size="md"
                    className="form-group-btn"
                  >
                    <FormattedMessage
                      id="pages.profile.security.button.disable"
                      defaultMessage="Disable"
                    />
                  </Button>
                </FormGroup>
              )} */}
            </Form>
            {showBotInfo && (
              <Card.Body className="telegram-info">
                <FormattedHTMLMessage
                  tagName="p"
                  id="pages.profile.security.telegram.auth-err"
                  values={botsInfo}
                />
              </Card.Body>
            )}
            {isActivating && (
              <TwoFactorActivateBlock
                sessionId={sessionId}
                validTill={validTill}
                onSubmit={onSubmit}
                error={message}
                status={code}
                two_factor={two_factor}
                phone={profile.phone}
              />
            )}
          </div>
          <div className="security-page-wrapper">
            <p className="security-page-title">
              <FormattedMessage id="password.title" defaultMessage="Password" />
            </p>
            <ChangePasswordBlock />
          </div>
        </div>
      </Layout.Col>
    </Layout>
  );
};

export default View;
